import clsx from 'clsx';
import { useContext } from 'react';

import styled from '@emotion/styled';

import { TableGroupContext } from './TableGroup';

export const TableGroupTitles = () => {
  const tableGroupContext = useContext(TableGroupContext);

  const handleStateChange = (title: string) => {
    tableGroupContext?.setQueryParams({ 'tab-segment': title });
  };

  return (
    <TableGroupWrapper>
      <TableGroupTitleWrapper>
        {tableGroupContext?.groupTitles.map((title, index) => {
          return (
            <div
              className={clsx(
                title === tableGroupContext?.queryParams.get('tab-segment')
                  ? 'activeSegment'
                  : '',
              )}
              onClick={() => handleStateChange(title)}
              key={index}
            >
              {title}
            </div>
          );
        })}
      </TableGroupTitleWrapper>
    </TableGroupWrapper>
  );
};

// Styles

const TableGroupWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;

  @media (max-width: 884px) {
    border-bottom: 1px solid ${({ theme }) => theme.palette.borderColor};
    margin-bottom: 28px;
  }
`;

const TableGroupTitleWrapper = styled.div`
  display: grid;
  grid-auto-flow: column;
  grid-auto-columns: max-content;
  gap: 24px;

  @media (max-width: 884px) {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    row-gap: 12px;
    column-gap: 24px;
    border-bottom: none;
  }

  & > * {
    text-align: left;
    padding: 14px 8px;
    line-height: 22px;
    font-size: 14px;
    font-weight: 400;
    color: ${({ theme }) => theme.palette.darkGrayText};
    cursor: pointer;
    width: fit-content;
  }

  & > *:hover {
  }

  & > .activeSegment {
    font-weight: 700;
    color: ${({ theme }) => theme.palette.darkGrayText};
    border-bottom: 2px solid ${({ theme }) => theme.palette.blueColor};
    box-shadow: 0px 1px 0 0 ${({ theme }) => theme.palette.blueColor};

    @media (max-width: 884px) {
      box-shadow: none;
    }
  }
`;
